import { motion } from "framer-motion";
import { Trophy } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1770237710424-7ffa780f68d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxzcG9ydHMlMjBjb2FjaCUyMGF0aGxldGUlMjBtZW50YWwlMjBmb2N1cyUyMGRhcmslMjBzdGFkaXVtJTIwbGlnaHRzfGVufDB8fHx8MTc4ODc4MDY4M3ww&ixlib=rb-4.1.0&q=85";

export const ChiSono = () => (
  <section id="chi-sono" data-testid="chi-sono-section" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="relative order-2 lg:order-1">
        <div className="absolute -inset-4 bg-sky-500/10 rounded-3xl blur-2xl" />
        <img src={IMG} alt="Mental coach con giovane atleta" data-testid="coach-portrait-img"
             className="relative rounded-3xl border border-[#222A3B] object-cover w-full aspect-[4/5] shadow-2xl" />
        <div data-testid="coach-experience-card"
             className="absolute -bottom-6 -right-2 sm:right-6 bg-[#181E2B]/95 backdrop-blur-xl border border-sky-500/30 rounded-2xl p-4 flex items-center gap-3 shadow-[0_0_30px_rgba(56,189,248,0.15)]">
          <Trophy className="w-8 h-8 text-sky-400" />
          <div>
            <p className="font-heading font-bold text-white">Registro Nazionale Coach Professionisti</p>
            <p className="text-xs text-slate-400">Riconosciuto dal CONI · Settori giovanili</p>
          </div>
        </div>
      </motion.div>
      <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="order-1 lg:order-2">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400">Chi Sono</span>
        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
          Alleno la mente dei giovani atleti come si allena un muscolo
        </h2>
        <p className="mt-5 text-base text-slate-300 leading-relaxed">
          Sono un Mental Coach sportivo professionista, iscritto al Registro Nazionale
          dei Coach Professionisti e riconosciuto dal CONI. Ho voluto specializzare il mio
          intervento rivolgendomi ai settori giovanili. La mia missione è semplice: dare ad
          ogni giovane atleta gli strumenti per{" "}
          <strong className="text-white">configurare il proprio stato emotivo</strong> —
          esattamente come un sistema intelligente ottimizza i suoi parametri — e scendere
          in campo nella versione migliore di sé.
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <div className="bg-white/95 rounded-xl px-4 py-2.5 flex items-center shadow-lg">
            <img src="/logo-renacop.png" alt="RENACOP — Registro Nazionale Coach Professionisti"
                 data-testid="logo-renacop" className="h-12 w-12 object-contain" />
          </div>
          <div className="bg-white/95 rounded-xl px-5 py-3 flex items-center shadow-lg">
            <img src="/logo-coni.svg" alt="CONI — Comitato Olimpico Nazionale Italiano"
                 data-testid="logo-coni" className="h-8 object-contain" />
          </div>
          <p className="text-xs text-slate-500 max-w-[180px]">Iscrizione e riconoscimento ufficiali</p>
        </div>
      </motion.div>
    </div>
  </section>
);
